import { Request } from "@/data/Requests"

async function SupportListAwardTypes() {
  return await Request(`/support/award-types`, {
    method: "GET",
  })
}

async function SupportCreateAwardType(awardType) {
  return await Request(`/support/award-type`, {
    method: "POST",
    data: awardType,
  })
}

async function SupportEditAwardType(awardType) {
  return await Request(`/support/award-type`, {
    method: "PUT",
    data: awardType,
  })
}

async function AdminListAwardTypes(globalSportId) {
  return await Request(`/admin/award-types/${globalSportId}`, {
    method: "GET",  
  })
}

export default {
  SupportListAwardTypes,
  SupportCreateAwardType,
  SupportEditAwardType,
  AdminListAwardTypes,
}